import { formatTypes } from '../../helpers/format-types';
import { join } from '../../helpers/join';

export function StatusBar({
  openFilters,
  isFiltersOpened,
  isLoading,

  count,
  status,
  areas,
  types,
  priceMin,
  priceMax,
  bedroom,
  bathroom,
  garage,
  parking,
  floorSize,
  maxFloorSize,
  landSize,
  pool,
  pets,
  flatlet,
  staffRooms,
  development,
  onShow,
  reduced,
  furnished,
  features,
}) {


  return (
    <div
      className={`map-search__status-bar`}
      onClick={openFilters}
    >
      {isLoading ? (
        <Loading />
      ) : isFiltersOpened ? (
        <Filters />
      ) : (
        <>
          <CountAndType count={count} types={types} />
          <Status status={status} />
          <Areas areas={areas} />
          <Price priceMin={priceMin} priceMax={priceMax} />
          <With bedroom={bedroom} bathroom={bathroom} garage={garage} parking={parking} floorSize={floorSize} maxFloorSize={maxFloorSize} landSize={landSize} pool={pool} pets={pets} flatlet={flatlet} staffRooms={staffRooms} development={development} onShow={onShow} reduced={reduced} furnished={furnished} />
          <Having features={features} />
        </>
      )}
    </div>
  );
}

function Loading() {
  return <>Loading results</>;
}

function Filters() {
  return <>Adjusting filters</>;
}

function CountAndType({ count, types }) {
  return <>{count} {formatTypes(types)}</>;
}

function Status({ status }) {
  return <> {status?.value.toLowerCase()}</>;
}

function Areas({ areas }) {
  return !!areas?.length && (
    <> in <span>{join(areas.map(x => x.term))}</span></>
  );
}

function Price({ priceMin, priceMax }) {
  if (!priceMin && !priceMax) return null;

  return (
    <>
     {!!priceMin && <> from {priceMin.name}</>}
     {!!priceMax && <> up to {priceMax.name}</>}
    </>
  );
}

function With({
  bedroom,
  bathroom,
  garage,
  parking,
  floorSize,
  maxFloorSize,
  landSize,
  pool,
  pets,
  flatlet,
  staffRooms,
  development,
  onShow,
  reduced,
  furnished,
}) {
  let tags = [];

  if (bedroom) tags.push(`${bedroom.name} beds`);
  if (bathroom) tags.push(`${bathroom.name} baths`);
  if (garage) tags.push(`${garage.name} garages`);
  if (parking) tags.push(`${parking.name} parking`);
  if (floorSize) tags.push(`floor ${floorSize.name}`);
  if (maxFloorSize) tags.push(`floor up to ${maxFloorSize.name}`);
  if (landSize) tags.push(`land ${landSize.name}`);
  if (pool) tags.push(`pool`);
  if (pets) tags.push(`pets allowed`);
  if (flatlet) tags.push(`flatlet`);
  if (staffRooms) tags.push(`staff rooms`);
  if (development) tags.push(`development`);
  if (onShow) tags.push(`on show`);
  if (reduced) tags.push(`reduced`);
  if (furnished) tags.push(`furnished`);

  return tags.length ? <> with {join(tags)}</> : null;
}

function Having({ features }) {
  if (!features || !Object.keys(features).length) return null;

  return <> having {join(Object.keys(features).sort())} tags</>;
}
